module.exports = __webpack_public_path__ + "static/event-46effe4fbfed840c71a214749b083f8f.png";